import React from "react";
import Box from "@carrier-io/air-react/Box";
import { ControllablePasswordInput } from "../controllable/PasswordInput";
import {
  PasswordRequirements,
  PasswordRequirementsErrorsType,
} from "../passwordRequirements/PasswordRequirements";
import { useForm } from "react-hook-form";
import { SetNewPasswordInput } from "../../validations/setNewPasswordValidation";
import { classValidatorResolver } from "@hookform/resolvers/class-validator";

type SetNewPasswordForm = {
  onSubmit: ({
    password,
    confirmPassword,
  }: {
    password: string;
    confirmPassword: string;
  }) => void;
  submitButton: (isValid: boolean) => React.ReactNode;
  passwordLabel?: string;
};

// Strange bug with eslint
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SetNewPasswordForm = ({
  onSubmit,
  submitButton,
  passwordLabel = "Set your password",
}: SetNewPasswordForm) => {
  const resolver = classValidatorResolver<SetNewPasswordInput>(
    SetNewPasswordInput,
    {
      validator: {
        stopAtFirstError: false,
      },
    },
  );

  const {
    control,
    handleSubmit,
    clearErrors,
    formState: { errors, isValid },
  } = useForm<SetNewPasswordInput>({
    mode: "onBlur",
    resolver,
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });

  const passwordErrors = (errors.password?.message?.split(", ") || []).reduce(
    (accum, error) => {
      accum[error as keyof PasswordRequirementsErrorsType["errors"]] = true;
      return accum;
    },
    {} as PasswordRequirementsErrorsType["errors"],
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box marginTop="16px">
        <ControllablePasswordInput
          control={control}
          clearErrors={clearErrors}
          name="password"
          type="password"
          label={passwordLabel}
          error={errors?.password?.message}
          hideHelperText
          showBorder
          fullWidth
          hideBackgroundColor
          size="xlarge"
        />
        <PasswordRequirements errors={passwordErrors} />
      </Box>
      <Box paddingTop="16px" height="64px">
        <ControllablePasswordInput
          control={control}
          clearErrors={clearErrors}
          name="confirmPassword"
          type="password"
          label="Confirm password"
          error={errors?.confirmPassword?.message}
          helperText={isValid && "Passwords match"}
          FormHelperTextProps={
            isValid
              ? {
                  sx: { color: "#2A862C" },
                }
              : {}
          }
          showBorder
          fullWidth
          hideBackgroundColor
          size="xlarge"
        />
      </Box>
      <Box marginTop="44px">{submitButton(isValid)}</Box>
    </form>
  );
};
